import React from 'react';
import './SideNavigation.scss';
import { useNavigate } from 'react-router-dom';
import SideNav, { SideNavItem } from '@trackman/web-shared-components/components/SideNav/SideNav';
import { getMenuItems } from 'utilities/menuItems';
import { useCanUserSeeOrganizations, useIsUserAdmin } from 'queryHooks/permissions';
import { useMenuStore } from 'stores/MenuStore';
import useMediaQuery from '@mui/material/useMediaQuery';

export const SideNavigation = () => {
  const { data: isUserAdmin } = useIsUserAdmin(true);
  const { data: organizations } = useCanUserSeeOrganizations(true);
  const navigate = useNavigate();

  const { isMenuOpen, selectedMenuItem, setIsMenuOpen, isMobileMenuOpen, setIsMobileMenuOpen } = useMenuStore();
  const isMobile = useMediaQuery('(max-width: 899px)');

  const menuItems: SideNavItem[] = getMenuItems(organizations?.length > 0, isUserAdmin ?? false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const navigationItems = menuItems.map((item) => ({
    ...item,
    ...(!item.subitems && item.href
      ? {
          onClick: (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            navigate(item.href!);
            if (isMobile) {
              closeMobileMenu();
            }
          },
          selected: selectedMenuItem === item.id,
        }
      : {}),
    ...(item.subitems
      ? {
          defaultOpen: selectedMenuItem === item.id || item.subitems.some((sub) => selectedMenuItem === sub.id),
          subitems: item.subitems.map((sub) => ({
            ...sub,
            ...(sub.href
              ? {
                  onClick: (e: React.MouseEvent<HTMLElement>) => {
                    e.preventDefault();
                    navigate(sub.href!);
                    if (isMobile) {
                      closeMobileMenu();
                    }
                  },
                  selected: selectedMenuItem === sub.id,
                }
              : {}),
          })),
        }
      : {}),
  }));

  return (
    <>
      {isMobile && !isMobileMenuOpen ? (
        <></>
      ) : (
        <>
          {isMobile && <div className='side-navigation-backdrop' onClick={closeMobileMenu} />}
          <div className={`side-navigation-wrapper${isMobile ? ' mobile-open' : ''}`}>
            <SideNav
              navigation={(navigationItems as SideNavItem[]) || []}
              open={isMobile ? true : isMenuOpen}
              setOpen={() => setIsMenuOpen(!isMenuOpen)}
            />
          </div>
        </>
      )}
    </>
  );
};
